// extracted by mini-css-extract-plugin
export var measureBox = "_au-0";